<div  *ngIf="formInit">
  <div   *ngIf="leadStyle == 2" style="width: 100%" [formGroup]="form" [fxLayoutGap]="gapBetweenImage">

    <ng-container *ngFor="let field of fields let i=index">

      <ng-container *ngIf="!field.enableConditionalField || field.visible">


        <ng-container *ngIf="field.inputType !== 'button'; else buttonContainer">
          <div  *ngIf="field.label!='LeadStatus' || field.label!='Stage'">

            <div [fxFlex]="layout == 2 ? 
            (gapBetweenImage ?  'calc(50% - ' + (gapBetweenImage) + ')' : '50%') 
            : (layout == 3 ? (gapBetweenImage ? 'calc(33.33% - ' + gapBetweenImage + ')' : '33.33%') 
              : (layout == 4 ? (gapBetweenImage ? 'calc(25% - ' + gapBetweenImage + ')' : '25%') 
                : '100'))" style="color: #111;">
              <div style="color: #111;" [type]="type" (valueChange)="onFieldValueChange($event)" [formType]="formType"  dynamicField [field]="field" [group]="form"></div>
            </div>
          </div>
       
        </ng-container>
        <ng-template #buttonContainer>
          <div fxFlex="100">
            <button [attr.guide]="'simple-dynamic-form-btn-1' + '__' + sanitizeUrl(url)" (click)="onSubmit()" fxFlex style="color:#111" mat-raised-button
              class="primary">{{field.label}}</button>
          </div>
        </ng-template>
      </ng-container>
    </ng-container>

  </div>
  <div   *ngIf="leadStyle == 1" style="width: 100%" [formGroup]="form" [fxLayoutGap]="gapBetweenImage">

    <ng-container *ngFor="let field of fields let i=index">

      <ng-container *ngIf="!field.enableConditionalField || field.visible">


        <ng-container *ngIf="field.inputType !== 'button'; else buttonContainer">
          <div  *ngIf="field.label!='LeadStatus' || field.label!='Stage'">

            <div [fxFlex]="layout == 2 ? 
            (gapBetweenImage ?  'calc(50% - ' + (gapBetweenImage) + ')' : '50%') 
            : (layout == 3 ? (gapBetweenImage ? 'calc(33.33% - ' + gapBetweenImage + ')' : '33.33%') 
              : (layout == 4 ? (gapBetweenImage ? 'calc(25% - ' + gapBetweenImage + ')' : '25%') 
                : '100'))">
              <div [type]="type" (valueChange)="onFieldValueChange($event)" [formType]="formType"  dynamicField [field]="field" [group]="form"></div>
            </div>
          </div>
       
        </ng-container>
        <ng-template #buttonContainer>
          <div fxFlex="100">
            <button [attr.guide]="'simple-dynamic-form-btn-2' + '__' + sanitizeUrl(url)" (click)="onSubmit()" fxFlex  style="color:white" mat-raised-button
              class="primary">{{field.label}}</button>
          </div>
        </ng-template>
      </ng-container>
    </ng-container>

  </div>

</div>

<!-- <pre>
    {{form.value |json}}
  </pre> -->
